import React, { Component } from 'react'
import { connect } from 'react-redux'

import {
    getCurrentAccount,
    getCurrentUser,
    getUserRoles,
    getApplicableProjects,
} from 'state/selectors'

import { withRouter } from 'react-router'

import {
    setOnboardingStep
} from 'state/actions'

import {
    doClickEventListeners,
    isMobile
} from 'utils'

import { merge } from 'lodash'

class Onboarder extends Component {
    state = {
        isVisible: false,
        hasBeenDismissed: false,
    }

    isClickOutsideDismissEnabled = false
    passedRandomChance = false

    UNSAFE_componentWillMount() {
        doClickEventListeners(this.handleClickOutside)

        this.assessVisibility()

        const randomDigit = Math.floor(Math.random() * (4 - 1 + 1)) + 1

        this.passedRandomChance = randomDigit === 1
    }

    componentWillUnmount() {
        doClickEventListeners(this.handleClickOutside, true)

        const {
            isVisible
        } = this.state

        if (isVisible) {
            this.dismissStep()
        }
    }

    UNSAFE_componentWillUpdate = nextProps => {
        const currentUser = this.props.user
        const nextUser = nextProps.user

        if (!currentUser.onboarded_enums || !nextUser.onboarded_enums) {
            return
        }

        if (currentUser.onboarded_enums.length && !nextUser.onboarded_enums.length) {
            this.setState({
                hasBeenDismissed: false
            })
        }
    }

    componentDidUpdate = _ => {
        if (this.state.isVisible && !this.shouldRender()) {
            this.dismissStep()
        }

        setTimeout(_ => {
            this.assessVisibility()
        }, 1)
    }

    assessVisibility = _ => {
        const {
            hasBeenDismissed,
            isVisible
        } = this.state

        const {
            setFocus,
        } = this.props

        if (!hasBeenDismissed && this.shouldRender() && !isVisible) {
            setTimeout(_ => {
                this.setState({
                    isVisible: true
                })

                if (setFocus) {
                    setFocus(true)
                }

                // just so you don't accidentally dismiss it too quick.
                setTimeout(_ => {
                    this.isClickOutsideDismissEnabled = true
                }, 800)
            }, 1000)
        }
    }

    handleClickOutside = e => {
        if (!this.isClickOutsideDismissEnabled) {
            return
        }

        const elementsToIgnoreClicksFrom = [this.ref, document.getElementById('dock'), document.getElementById('modal'), document.getElementById('header-tabs')]

        let clickContainsIgnoredElements = false

        elementsToIgnoreClicksFrom.forEach(element => {
            if (element && element.contains(e.target)) {
                clickContainsIgnoredElements = true
            }
        })


        if (!clickContainsIgnoredElements) {
            this.dismissStep()
        }
    }

    dismissStep = _ => {
        const {
            type,
            user,
            setOnboardingStep,
            setFocus
        } = this.props

        const {
            isVisible
        } = this.state

        if ((isVisible && this.isClickOutsideDismissEnabled) || type == 'CREATED_TASK') {
            if (setFocus) {
                setFocus(false)
            }

            this.setState({
                isVisible: false,
                hasBeenDismissed: true
            })

            const blacklist = ['CUSTOMISED_PROJECT', 'CREATED_PROJECT']

            if (!blacklist.includes(type)) {
                setTimeout(_ => {
                    setOnboardingStep(type, user)
                }, 300)
            }
        }
    }

    getCopy = _ => {
        const {
            type,
            user,
            accountData
        } = this.props

        const onboardedEnums = user.onboarded_enums ? user.onboarded_enums : []

        switch (type) {
            case 'CREATED_PROJECT':
                return {
                    title: "You must be new here!",
                    body: "Get started by creating a <em>project</em>."
                }
            case 'OPENED_OTHER_PROJECT':
                return {
                    title: `Good to see you, ${user.first_name}!`,
                    body: `Open a <em>project</em>, and we'll get started.`
                }
            case 'CREATED_MILESTONE_AND_TASK':
                return {
                    title: "Nice. You're almost there.",
                    body: "Create a <em>milestone</em>, and add a <em>task</em> or two."
                }
            case 'CREATED_TASK':
                return {
                    title: "Great! You're almost there.",
                    body: "Create a <em>task</em> under this <em>milestone</em>."
                }
            case 'OPENED_TASK':
                if (onboardedEnums.includes('OPENED_OTHER_PROJECT')) {
                    return {
                        title: 'Click to open a task',
                        body: 'Here you can <em>comment</em>, or upload <em>files</em>.'
                    }
                } else {
                    return {
                        title: "Great! Last step.",
                        body: "Click a <em>task</em> to open its <em>comment</em> feed."
                    }
                }
            case 'OPENED_PEOPLE_TAB':
                return {
                    title: `That's about it, ${user.first_name}!`,
                    body: "Add some <em>staff</em> to start collaborating."
                }
            case 'OPEN_CHATS':
                return {
                    title: `That's about it, ${user.first_name}!`,
                    body: `Perhaps say hello to the rest of <em>${accountData.name}</em>?`
                }
            case 'CUSTOMISED_PROJECT':
                return {
                    title: `Customize this project`,
                    body: `Add another <em>status</em> column, or perhaps a <em>text</em> field?`
                }
            case 'OPENED_TEAMS':
                return {
                    title: 'You can now create teams',
                    body: 'Keep your <em>projects</em> organized, and decide who can see what.'
                }
            case 'OPENED_USER':
                return {
                    title: "Click for stats and progress info",
                    body: "<em>Admins</em> and <em>Project Managers</em> only, of course."
                }
            case 'POSTED_ANNOUNCEMENT':
                return {
                    title: "Post an announcement here",
                    body: "It'll show up at the top of all your staff's dashboards."
                }
            case 'EVENT_CREATED':
                return {
                    title: "Create an event here",
                    body: "Lorem ipsum"
                }
        }
    }

    projectHas = entity => {
        const {
            project,
            allMilestones,
            allTasks
        } = this.props

        if (!project || !project.milestones) {
            return false
        }

        let firstMilestone = null

        const hasAtLeastOneMilestone = project.milestones.some(milestoneId => {
            const milestone = allMilestones[milestoneId]

            if (milestone && !milestone.deleted_at) {
                firstMilestone = milestone
                return true
            }
        })

        if (entity == 'milestone') {
            return hasAtLeastOneMilestone
        }

        const hasAtLeastOneTask = firstMilestone && firstMilestone.tasks && firstMilestone.tasks.some(taskId => {
            const task = allTasks[taskId]

            if (task && !task.deleted_at) {
                return true
            }
        })

        return hasAtLeastOneTask
    }

    shouldRender = _ => {
        const {
            type,
            user,
            accountData,
            userRoles,
            project,
            allProjects,
            onboarded_enums,
            location
        } = this.props

        if (!user || user.prevent_new_onboarding || isMobile()) {
            return false
        }

        const hasProjects = Object.keys(allProjects).length

        const onboardedEnums = user.onboarded_enums ? [...user.onboarded_enums] : []

        onboarded_enums && onboarded_enums.forEach(onboarded_enum => {
            if (!onboardedEnums.includes(onboarded_enum)) {
                onboardedEnums.push(onboarded_enum)
            }
        })

        if (onboardedEnums.includes(type)) {
            return false
        }

        const isSuperUser = userRoles.admin || userRoles.pm

        let shouldRender = false

        switch (type) {
            case 'CREATED_PROJECT':
                shouldRender = !onboardedEnums.length && userRoles.admin
                break
            case 'OPENED_OTHER_PROJECT':
                shouldRender = !onboardedEnums.length && hasProjects && !userRoles.admin
                break
            case 'CREATED_MILESTONE_AND_TASK':
                if (onboardedEnums.includes('CREATED_PROJECT')) {
                    shouldRender = true
                } else if (onboardedEnums.includes('OPENED_OTHER_PROJECT') && (!this.projectHas('milestone'))) {
                    shouldRender = true
                }

                if (onboardedEnums.includes('OPENED_TASK')) {
                    // If you've already done the 'open task' one, you don't need this.
                    shouldRender = false
                }

                break
            case 'CREATED_TASK': // if there's already an empty milestone
                shouldRender = onboardedEnums.includes('OPENED_OTHER_PROJECT') && onboardedEnums.includes('CREATED_MILESTONE_AND_TASK') && this.projectHas('milestone') && !this.projectHas('task')
                break
            case 'OPENED_TASK':
                shouldRender = (onboardedEnums.includes('CREATED_MILESTONE_AND_TASK') || onboardedEnums.includes('CREATED_TASK'))
                break
            case 'OPENED_PEOPLE_TAB':
                shouldRender = (onboardedEnums.includes('OPENED_TASK') && onboardedEnums.includes('OPEN_CHATS') && accountData.users.length == 1) // isSuperUser is redundant here.
                break
            case 'OPEN_CHATS':
                shouldRender = (onboardedEnums.includes('OPENED_TASK') && onboardedEnums.includes('OPENED_PEOPLE_TAB') && accountData.users.length > 1)
                break
            case 'CUSTOMISED_PROJECT':
                shouldRender = (onboardedEnums.includes('CREATED_TASK') || onboardedEnums.includes('CREATED_MILESTONE_AND_TASK')) && this.passedRandomChance
                break
            case 'OPENED_TEAMS':
                shouldRender = accountData.isPremium
                break
            case 'OPENED_USER':
                shouldRender = accountData.isPremium && isSuperUser && onboardedEnums.includes('OPENED_TEAMS')
                break
            case 'POSTED_ANNOUNCEMENT':
            case 'EVENT_CREATED':
                const showGettingStarted = location.search && location.search.includes('showGettingStarted')

                shouldRender = accountData.isPremium && showGettingStarted
                break
            case 'PROMPTED_CUSTOM_COLUMNS':
                shouldRender = onboardedEnums.length >= 3 && onboardedEnums.includes(type) && this.passedRandomChance && !accountData.isPremium
                break
        }

        return shouldRender
    }

    getSidebarFolderSystemHeight = _ => {
        const sidebarFolderSystem = document.getElementById('sidebar-folder-container')

        let height = 70

        if (sidebarFolderSystem) {
            height = sidebarFolderSystem.getBoundingClientRect().height
        }

        return height
    }

    render() {
        if (!this.shouldRender() || isMobile()) {
            return null
        }

        const {
            isVisible
        } = this.state

        const {
            direction,
            type,
            userRoles
        } = this.props

        const {
            title,
            body,
            link
        } = this.getCopy()

        let className = 'onboarder ' + direction + ' ' + type.toLowerCase()
        let forcedMarginTop = null

        if (isVisible) {
            className += ' visible'
        }

        if (type == 'OPENED_OTHER_PROJECT') {
            const sidebarFolderSystemHeight = this.getSidebarFolderSystemHeight()

            forcedMarginTop = 25 + (sidebarFolderSystemHeight / 2)
        }

        return (
            <a
                id="onboarder"
                className={className}
                style={forcedMarginTop ? {
                    marginTop: forcedMarginTop + 'px'
                } : null}
                ref={ref => this.ref = ref}
                href={link ? link : 'javascript:void(0)'}
                target={link ? "_blank" : ''}
            >
                <div
                    className="icon"
                    style={{
                        backgroundImage: `url(${document.base}/images/decoration/onboard-toaster-bg.jpg`
                    }}
                >
                    <img src={document.base + '/images/decoration/onboard-toaster-fg.png'} />
                </div>
                <div className="content">
                    <h3 dangerouslySetInnerHTML={{ __html: title }} />
                    <span dangerouslySetInnerHTML={{ __html: body }} />
                </div>
            </a>
        )
    }
}

const mapStateToProps = state => {
    return {
        accountData: getCurrentAccount(state),
        user: getCurrentUser(state),
        userRoles: getUserRoles(state),
        allProjects: getApplicableProjects(state),
        allMilestones: state.account.entities.milestones,
        allTasks: state.account.entities.tasks,
        onboarded_enums: state.auth.onboarded_enums
    }
}

export default withRouter(connect(mapStateToProps, { setOnboardingStep })(Onboarder))